export const listAbout   = [
    {
      bigtitle : {pt:'Especialistas em Materiais de Iluminação & Soluções Elétricas em Madrid', 
        en: "Specialists in Lighting Materials & Electrical Solutions in Madrid", 
        es: 'Especialistas en materiales de iluminación y soluciones eléctricas en Madrid', 
        fr: "Spécialistes en matériel d'éclairage et solutions électriques à Madrid",
        it: "Esperti in materiali per l'illuminazione e soluzioni elettriche a Madrid",
        de: "Experten für Beleuchtungsmaterialien und elektrische Lösungen in Madrid",
        zhCN: "马德里照明材料与电气解决方案专家"},
      text: { 
        pt: `
         <p>
           A IBEROLEC SUMINISTROS ELECTRICOS, S.L.U. está ao seu lado para tornar a sua experiência no mercado elétrico mais simples e eficiente. 
           Oferecemos suporte na escolha dos melhores produtos de iluminação e material elétrico, com soluções que 
           atendem desde residências até projetos industriais.
          </p>
          <p>
           O nosso portefólio inclui projetores industriais, lâmpadas LED para casa, piscina ou jardim, iluminação para 
           obras e espaços públicos, além de candeeiros que unem qualidade e estilo para valorizar qualquer ambiente 
           e muito mais. Tudo pensado para trazer mais segurança, eficiência e beleza ao seu dia a dia.
          </p>`,

        en: `       
        <p>
           IBEROLEC SUMINISTROS ELECTRICOS, S.L.U. is by your side to make your experience in the electrical market 
           simpler and more efficient. We provide support in choosing the best products in lighting and electrical materials, 
           with solutions for everything from homes to industrial projects.
          </p>
          <p>
            Our portfolio includes industrial projectors, LED lamps for home, pool or garden, lighting for construction and public 
            spaces, as well as lamps that combine quality and style to enhance any environment and much more. All designed to bring 
            more safety, efficiency, and beauty to your daily life.
          </p>`,
        es: ` 
         <p>
          IBEROLEC SUMINISTROS ELECTRICOS, S.L.U. está a tu lado para hacer tu experiencia en el mercado eléctrico más simple y eficiente. Ofrecemos apoyo en la elección de los 
        mejores productos en iluminación y material eléctrico, con soluciones que van desde viviendas hasta proyectos industriales.
        </p>
        <p>
          Nuestro portafolio incluye proyectores industriales, lámparas LED para el hogar, piscina o jardín, iluminación para obras y espacios públicos, 
        además de lámparas que combinan calidad y estilo para realzar cualquier ambiente y mucho más. Todo pensado para aportar más seguridad, eficiencia y belleza a tu día a día.
        </p>`,
        fr: `  
        <p>
         IBEROLEC SUMINISTROS ELECTRICOS, S.L.U. est à vos côtés pour rendre votre expérience sur le marché électrique plus simple et plus efficace. Nous offrons un accompagnement 
        dans le choix des meilleurs produits en éclairage et matériel électrique, avec des solutions allant des habitations aux projets industriels.
        </p>
        <p>
        Notre portefeuille comprend des projecteurs industriels, des lampes LED pour la maison, la piscine ou le jardin, un éclairage pour les chantiers et les 
        espaces publics, ainsi que des lampes alliant qualité et style pour valoriser tout environnement, et bien plus encore. Tout est pensé pour apporter plus 
        de sécurité, d’efficacité et de beauté à votre quotidien. 
        </p>`,
        it: `    
        <p>
        IBEROLEC SUMINISTROS ELECTRICOS, S.L.U. è al tuo fianco per rendere la tua esperienza nel mercato elettrico più semplice ed efficiente. Offriamo supporto 
        nella scelta dei migliori prodotti in illuminazione e materiale elettrico, con soluzioni che vanno dalle abitazioni ai progetti industriali. 
        </p>
        <p>
        Il nostro portafoglio include proiettori industriali, lampade LED per la casa, piscina o giardino, illuminazione per cantieri e spazi pubblici, oltre a lampade che 
        uniscono qualità e stile per valorizzare qualsiasi ambiente e molto altro. Tutto pensato per portare più sicurezza, efficienza e bellezza nella tua vita quotidiana.
        </p>`,
        de: `    
        <p>
        IBEROLEC SUMINISTROS ELECTRICOS, S.L.U. steht an Ihrer Seite, um Ihre Erfahrung auf dem Elektrizitätsmarkt einfacher und effizienter zu machen. Wir unterstützen
         Sie bei der Auswahl der besten Produkte in Beleuchtung und Elektromaterial, mit Lösungen für alles – von Wohnhäusern bis hin zu Industrieprojekten. 
        </p>
        <p>
         Unser Portfolio umfasst Industrieprojektoren, LED-Lampen für Zuhause, Pool oder Garten, Beleuchtung für Baustellen und öffentliche Räume sowie Leuchten, 
         die Qualität und Stil vereinen, um jede Umgebung aufzuwerten – und vieles mehr. Alles ist darauf ausgelegt, mehr Sicherheit, Effizienz und Schönheit in 
         Ihren Alltag zu bringen. 
        </p>`,
        zh: `    
        <p>
        IBEROLEC SUMINISTROS ELECTRICOS, S.L.U. 致力于为您提供更简单、更高效的电气市场体验。我们为您提供照明和电气设备产品的选择支持，提供从住宅到工业项目的一站式解决方案。
        </p>
        <p>
         我们的产品组合包括工业投影仪、家用LED灯、泳池或花园LED灯、建筑工地和公共空间照明设备，以及将品质与风格完美融合的灯具，可提升任何环境的格调，等等。
         所有产品均旨在为您的日常生活带来更高的安全性、效率和美感。. 
        </p>`,
      },
    },
]